import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import * as verificationActions from '../actions/verification';
import isEmpty from '../utils/emptyObject';

const {OKNAME_URL} = verificationActions;

class Verification extends Component {
  constructor(props) {
    super(props);

    this.state = {
      smsPopup: {}
    };
  }

  componentDidMount() {
    if (window.self === window.top) {
      document.body.className += ' verification-bg';
    }

    window.addEventListener(
      'message',
      event => {
        if (event.origin === OKNAME_URL) {
          verificationActions
            .smsCallbackAsync(this.props.dispatch, event.data, this.props.location.query)
            .then(() => {
              this.state.smsPopup.close();
              this.setState({smsPopup: {}});
            });
        }
      },
      false
    );
  }

  smsAuthentication() {
    this.closeAllWindows();
    this.setState({
      smsPopup: verificationActions.smsAsync(this.props.dispatch)
    });
  }

  closeAllWindows() {
    if (!isEmpty(this.state.smsPopup)) {
      this.state.smsPopup.close();
    }
  }

  render() {
    return (
      <div className="verification-page">
        <div className="verification-page_wrapper">
          <div className="verification-page_wrapper_logotype" />

          <div className="verification-page_wrapper_description">
            게임 계정을 생성하기 전에 신원을 확인하세요.
          </div>

          <div className="verification-page_wrapper_cards">
            <div className="item-card" data-testid="sms" onClick={() => this.smsAuthentication()}>
              <div className="item-card_title">휴대전화 본인 인증</div>

              <div className="item-card_description">
                본인 소유의 휴대전화 정보를 입력한 후 인증 번호를 입력하면 사용자 본인을 확인할 수
                있습니다.
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Verification.propTypes = {
  location: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired
};

export default connect(state => state)(Verification);



// WEBPACK FOOTER //
// ./pages/Verification.jsx